import { ITranslationTypes, TRANSLATION_TYPES_ACTIONS } from '../actions/translation-types.actions';

export const INITIAL_TRANSLATION_TYPES: ITranslationTypes = {
  translationTypes: [],
  filteredTranslationTypes: []
};

export function translationTypesReducer(state: ITranslationTypes = INITIAL_TRANSLATION_TYPES, action) {
  switch (action.type) {

    case TRANSLATION_TYPES_ACTIONS.SET_TRANSLATION_TYPES:
      return Object.assign([], action.payload);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/translation-types.reducer.ts